var map = {
	"./icon_instagram_justify_0.png": "./src/assets/img/icon_instagram_justify_0.png",
	"./icon_instagram_justify_1.png": "./src/assets/img/icon_instagram_justify_1.png",
	"./icon_instagram_justify_2.png": "./src/assets/img/icon_instagram_justify_2.png",
	"./icon_instagram_justify_center.png": "./src/assets/img/icon_instagram_justify_center.png",
	"./icon_instagram_justify_left.png": "./src/assets/img/icon_instagram_justify_left.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/icon_instagram_justify_.*\\.png$";